import type { CriterionTranscriptionAssignment } from '../../types';

export interface AssignmentPair {
  criteriaId: string;
  transcriptionId: string;
}

export interface PairCopyBulkRequest {
  criteriaId: string;
  userIds: string[];
  transcriptionIds: string[];
}

const pairKey = (pair: AssignmentPair): string => `${pair.criteriaId}:${pair.transcriptionId}`;

export const uniqueAssignmentPairs = (
  assignments: Pick<CriterionTranscriptionAssignment, 'criteriaId' | 'transcriptionId'>[]
): AssignmentPair[] => {
  const seen = new Set<string>();
  const pairs: AssignmentPair[] = [];
  assignments.forEach(assignment => {
    const pair = {
      criteriaId: assignment.criteriaId,
      transcriptionId: assignment.transcriptionId,
    };
    const key = pairKey(pair);
    if (seen.has(key)) return;
    seen.add(key);
    pairs.push(pair);
  });
  return pairs;
};

export const pairCopyBulkRequests = (
  pairs: AssignmentPair[],
  userIds: string[]
): PairCopyBulkRequest[] => {
  const transcriptionIdsByCriterion = new Map<string, string[]>();
  pairs.forEach(pair => {
    const transcriptionIds = transcriptionIdsByCriterion.get(pair.criteriaId);
    if (transcriptionIds) {
      if (!transcriptionIds.includes(pair.transcriptionId)) {
        transcriptionIds.push(pair.transcriptionId);
      }
      return;
    }
    transcriptionIdsByCriterion.set(pair.criteriaId, [pair.transcriptionId]);
  });

  return Array.from(transcriptionIdsByCriterion.entries())
    .sort(([left], [right]) => left.localeCompare(right))
    .map(([criteriaId, transcriptionIds]) => ({
      criteriaId,
      userIds,
      transcriptionIds,
    }));
};
